<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // 从store中获取需要缓存的组件名称
    cachedViews() {
      return this.$store.state.app.cachedViews
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue